import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Fonts } from '../Label.h'

export interface ILabelInlinePrimaryTemplateProps extends ILabelProps {
  className?: string
}

export const LabelInlinePrimaryTemplate = ({
  title = '',
  font = Fonts.Caption4,
  color = COLOR.TEXT_ICON_CONSTANT_LIGHT,
  ...rest
}: ILabelInlinePrimaryTemplateProps): JSX.Element => (
  <Label title={title} font={font} color={color} {...rest} />
)
